import React from "react";
import moment from "moment";
// import { useContext } from "react";
import { formatMonto } from "../../utils";
// import { AdjuntosContext } from "../../context/AdjuntosContext";

const FilaPago = ({ pago, index, editPago, cancelPago, permiso }) => {
  const {
    monto,
    // idAdjunto,
    comentario,
    // nombre_adjunto,
    monto_amortizado,
    fecha_cancelacion,
    fecha_hora_autorizacion,
  } = pago;

  // const { setSingleAdjunto } = useContext(AdjuntosContext);

  return (
    <tr>
      <td>{index + 1}</td>
      <td>{comentario}</td>
      <td>
        {"$"}
        {formatMonto(monto)}
      </td>
      <td>
        {"$"}
        {formatMonto(monto_amortizado)}
      </td>
      <td>{moment(fecha_hora_autorizacion).format("DD MMM YYYY")}</td>
      {/*
      <td>
        {idAdjunto &&
          (idAdjunto !== null) &
            6(
              <button
                className="btn btn-link text-primary"
                onClick={() =>
                  setSingleAdjunto({
                    idAdjunto,
                    nombre: nombre_adjunto,
                    tipo: "jpg",
                  })
                }
              >
                <i className="fa fa-eye"></i>
              </button>
            )}
      </td>
      */}
      <td>
        {fecha_cancelacion === null &&
          ["admin", "finanzas"].includes(permiso) && (
            <button
              className="btn btn-sm btn-outline-primary me-2"
              onClick={() => editPago(pago)}
            >
              <i className="fa fa-edit"></i>
            </button>
          )}
        {fecha_cancelacion === null &&
          ["admin", "finanzas"].includes(permiso) && (
            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => cancelPago(pago)}
            >
              <i className="fa fa-times"></i>
            </button>
          )}
        {fecha_cancelacion && fecha_cancelacion !== null && (
          <span className="text-danger small">
            CANCELADO: {moment(fecha_cancelacion).format("DD MMM YYYY")}{" "}
          </span>
        )}
      </td>
    </tr>
  );
};

export default FilaPago;
